





























import { computed, defineComponent } from '@nuxtjs/composition-api';

import { useDeclination } from '~/diptyqueTheme/composable/useDeclination';

export default defineComponent({
  name: 'VaimoButtons',
  components: {
    VaimoButton: () => import('atoms/VaimoButton.vue')
  },
  props: {
    sectionData: {
      type: Object,
      required: true
    },
    block: {
      type: Boolean,
      default: false
    },
    positionFilter: {
      type: String,
      required: false,
      default: 'Default'
    },
    forceShowSubmit: {
      type: Boolean,
      required: false,
      default: false
    },
    countdownEmail: {
      type: Boolean,
      required: false,
      default: false
    },
    calendarData: {
      type: Object,
      required: false,
      default: () => ({})
    }
  },
  emits: ['show-registration-form', 'add-to-cart', 'event-click'],
  setup(props) {
    const { getButtonDataFunction, isButtonEntry } = useDeclination(
      props.sectionData
    );

    const buttons = computed(() => {
      // Single button case
      if (props.sectionData?.button) {
        const btn = getButtonDataFunction(props.sectionData.button);
        return btn?.isButtonVisible ? [btn] : [];
      }

      // Button collection case
      const items = props.sectionData?.buttonCollection?.items;
      if (!Array.isArray(items)) return [];

      return items
        .filter((item) => isButtonEntry(item))
        .map((item) => {
          const buttonData = getButtonDataFunction(item);

          // Hide calendar button if expired
          const calendarExpired =
            buttonData.isCalendarButton && props.calendarData.isExpired;

          return {
            ...buttonData,
            ...(calendarExpired ? { isButtonVisible: false } : {})
          };
        })
        .filter((item) => item.isButtonVisible)
        .filter((item) => item.position === props.positionFilter);
    });

    return {
      buttons
    };
  }
});
